import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { createErrorMessage, ValidationMessage } from './validation-message';
import i18next from 'i18next';

@Component({
  selector: 'pf-validation-message',
  standalone: true,
  imports: [],
  templateUrl: './validation-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ValidationMessageComponent {
  readonly validationMessages = input<ReadonlyArray<ValidationMessage> | null>(null);
  readonly name = input<string>('');

  readonly message = computed(() => {
    const messages = this.validationMessages();
    if (!messages?.length) {
      return i18next.t(`sendmail.form.validation.default`) + `: ${this.name()}`;
    }
    const message = messages[0];
    return createErrorMessage(message);
  });
}
